import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TerminalData} from "../terminal.data";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: "wbo-terminal-type-select-options",
    templateUrl: "./terminal-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => TerminalTypeSelectOptionsComponent),
        multi: true
    }]
})
export class TerminalTypeSelectOptionsComponent extends SelectOptionsComponent {
    TerminalData = TerminalData;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
